import {Injectable, NgZone}              from "@angular/core";
import {AuthState, CognitoUserInterface} from "@aws-amplify/ui-components";
import {Amplify, Auth, DataStore, Hub}   from "aws-amplify";
import {ActivatedRoute, Router}          from "@angular/router";
import {Roles}                           from "../enums/enums";
import {BehaviorSubject}                 from "rxjs";
import {Team, User}                      from "../../models";
import {NavController, Platform}         from "@ionic/angular";
import {
    APIService,
    CreateUserInput,
    GetUserQuery,
    PermissionType,
    UpdateUserInput,
}                                        from "../API.service";
import OneSignal                         from 'onesignal-cordova-plugin';

@Injectable({
    providedIn: "root",
})
export class SessionService {
    user: GetUserQuery;
    theme: string = "blue";
    permessionTypes = PermissionType;

    getTheme() {
        return localStorage.getItem("theme") || "";
    }

    getBookmarks() {
        return JSON.parse(localStorage.getItem("bookmarks") || "[]");
    }

    userList: any[];
    authState: string;
    private cognitoUser: CognitoUserInterface;
    user$ = new BehaviorSubject<GetUserQuery>(null);
    permissionType = PermissionType;
    private ready: boolean = false;

    constructor(
            private api: APIService,
            private router: Router,
            private platform: Platform,
            private apiService: APIService,
            private route: NavController,
            private activateRoute: ActivatedRoute,
            private ngZone: NgZone
    ) {
        const listener = (data) => {
            
            switch (data.payload.event) {
                case "signIn":
                    Auth.currentAuthenticatedUser().then((value) => {
                        
                        this.setNewAuthState(value, AuthState.SignedIn);
                    });
                    break;
                case "signUp":
                    console.info("user signed up");
                    break;
                case "signOut":
                    console.info("user signed out");
                    this.authState = AuthState.SignedOut;
                    this.user = null;
                    this.setNewAuthState(this.user, AuthState.SignedOut);
                    break;
                case "signIn_failure":
                    console.error("user sign in failed");
                    break;
                case "tokenRefresh":
                    console.info("token refresh succeeded");
                    break;
                case "tokenRefresh_failure":
                    console.error("token refresh failed");
                    break;
                case "configured":
                    console.info("the Auth module is configured");
            }
        };
        Hub.listen("auth", listener);
    }

    async setUserListner() {
        const listener = Hub.listen("datastore", async (hubData) => {
            const {event, data} = hubData.payload;
            // 
            if (event === "outboxStatus") {
                if (data.isEmpty){}

            }

            if (event === "ready") {
                
                this.ready = true;
            }
        });
    }

    async setUser(userCognito: CognitoUserInterface) {
        /*   while (this.ready == false) {
                   await new Promise((resolve) => setTimeout(resolve, 1000));
                   
               }*/

        this.cognitoUser = userCognito;
        try {
            //  await this.api.DeleteUser({id: 'ba502f9a-c6d7-417e-b2de-7ca9c04bc64e'});
            

            this.user = null;
            if (!this.user) {
                const usersByEmail = await this.api.UserByEmail(
                        userCognito.attributes.email,
                        undefined,
                        undefined,
                        10000
                );
                
                try {
                    if (usersByEmail.items.length > 0) {
                        // @ts-ignore
                        this.user = usersByEmail.items.find((x) => x._deleted != true);
                        

                        if (
                                this.user.permessions == PermissionType.ADMINISTRATOR &&
                                this.user.teamID == null
                        ) {
                            let t = await this.api.CreateTeam({
                                name: this.user.lastname + " " + this.user.name,
                                teamManagerId: this.user.id,
                            });
                            await this.api.UpdateUser({
                                id: this.user.id,
                                teamID: t.id,
                                _version: this.user._version,
                            });
                        }
                    }
                } catch (e) {
                }
            }

            if (!this.user) {
                
            }

            if (!this.user) {
                const user: CreateUserInput = {
                    name: userCognito.attributes.name,
                    lastname: userCognito.attributes.family_name,
                    email: userCognito.attributes.email.toLowerCase().trimEnd(),
                    phoneNumber: userCognito.attributes.phone_number,
                    role: Roles.CLIENT.displayName,
                    permessions: PermissionType.CLIENT,
                };
                try {
                    const us = await this.createUser(user);
                    this.user = us;
                    
                } catch (e) {
                    
                    const u = await this.api.GetUser(userCognito.attributes.sub);
                    
                    return await this.logOut();
                }
            }
            this.user$.next(this.user);
            

            await this.initOneSignalnotAsync();
            ///   this.setUserUpdateListenr();
        } catch (e) {
            console.error("errore set utente", e);
        }
    }

    async createUser(user: CreateUserInput) {
        return await this.api.CreateUser(user);
    }

    canRender() {
    }

    signout() {
        this.user = null;
    }

    getCurrentUser() {
        if (this.user) {
            return this.user;
        } else {
            // forse c'e' sarà da fare il check del login
            return this.user;
        }
    }

    async logOut() {
        try {
            /*
                                    if (this.user) {
                                        const m = await this.api.UpdateUser({
                                            id: this.user.id,
                                            device_id: null,
                                            _version: this.user._version,
                                        });
                                        
                                        // DataStore.save(User?.copyOf(this.user, d => d.device_id = null));
                                    }
                        */

            

            // await DataStore.start();
            

            await Auth.signOut();
            await DataStore.clear();
            await DataStore.start();
            this.user = undefined;
            this.cognitoUser = undefined;
            this.authState = undefined;

            //  this.cd.detectChanges();
        } catch (e) {
            
        }
    }

    async setNewAuthState(value, state = "") {
        this.authState = state;
        const cognitouser = value;

        
        switch (this.authState) {
            case AuthState.SignedIn:
                
                await this.setUser(cognitouser);
                let returnUrl = decodeURIComponent(
                        this.activateRoute["_routerState"].snapshot.url
                );
                if (returnUrl.includes("returnUrl"))
                    returnUrl = returnUrl.split('=')[1]
                if (
                        returnUrl == null ||
                        returnUrl == undefined ||
                        returnUrl == "undefined" || returnUrl == '/login'
                ) {
                    if (this.user.permessions == PermissionType.CLIENT) {
                        returnUrl = "/home";
                    } else {
                        returnUrl = "/home";
                    }
                }

                if (!this.user?.name || !this.user?.lastname)
                    returnUrl = 'setInfo';

                
                this.ngZone.run(() => {
                    this.router.navigateByUrl(returnUrl);
                });
                break;
            case AuthState.SignedOut:
                await this.route.navigateRoot("/login");
        }
    }

    async setAuthState(value, state = "signedIn") {
        if (value.state === "signedIn") {
            this.authState = AuthState.SignedIn;
        } else if (value.state == "signedOut") {
            this.authState = AuthState.SignedOut;
        }

        const cognitouser = value.user as CognitoUserInterface;
        if (this.authState == AuthState.SignedIn) {
            
        } else {
            
        }
        
        switch (this.authState) {
            case AuthState.SignedIn:
                
                await this.setUser(cognitouser);
                let returnUrl = decodeURIComponent(
                        this.activateRoute["_routerState"].snapshot.url
                );
                if (
                        returnUrl == null ||
                        returnUrl == undefined ||
                        returnUrl == "undefined" || returnUrl == '/login'
                ) {
                    if (this.user.permessions == PermissionType.CLIENT) {
                        returnUrl = "/home";
                    } else {
                        returnUrl = "/home";
                    }
                }
                
                this.ngZone.run(() => {
                    this.router.navigateByUrl(returnUrl);
                });
                break;
            case AuthState.SignedOut:
                await this.route.navigateRoot("/login");
        }
    }

    private async initOneSignal() {
        // TODO implement one signal init
    }

    initOneSignalnotAsync() {
        if (this.platform.is("android") || this.platform.is("ios")) {
            OneSignal.login(this.user.id);
         const onesignalId =   OneSignal.User.pushSubscription.id
                if (this.user?.device_id != onesignalId) {
                    
                    //     
                    const userUpdateInput: UpdateUserInput = {
                        id: this.user.id,
                        device_id: onesignalId.toString(),
                        _version: this.user._version,
                    };
                    this.apiService
                            .UpdateUser(userUpdateInput)
                            .then((u) => {
                                this.user = u;

                            })
                            .catch((errore) => {
                            });
                }

            if (this.user?.email) {
                
                OneSignal.User.addEmail(this.user.email);
            }
        }
    }

    gotoHome() {
        this.router.navigateByUrl("/home");
    }
}

// export enum Roles {
//     ADMIN = 'Administrator',
//     ADVISOR = 'Advisor',
//     SENIOR = 'Senior Agent',
//     JUNIOR = 'Junior Agent',
//     CLIENT = 'Client',
// }
